import React, { useState, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { format, subDays, setHours, setMinutes, setSeconds } from 'date-fns';
import { includes, isEmpty } from 'lodash';
import * as Yup from 'yup';
import { GPP, FRENTISTA } from '~/constants/perfil';
import { t, parseDateString } from '~/helpers';
import { Report, ListTransfer } from '~/components';
import { Autocomplete, DateTime, RadioGroup } from '~/components/Form';

export default function Relvazaonaoautorizadapostosperiodo() {
  const [open, setOpen] = useState(true);
  const [produto, setProduto] = useState({ prod_codigo: '' });
  const [posts, setPosts] = useState([]);
  const { profile } = useSelector((state) => state.user);
  const [postoDescricaoAbrev, setPostoDescricaoAbrev] = useState('');

  const umPosto = useMemo(
    () => includes([GPP, FRENTISTA], profile.glousuariotipo),
    [profile.glousuariotipo]
  );

  const datahorainicial = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(subDays(new Date(), 7), 0), 0), 0),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const datahorafinal = useMemo(
    () =>
      format(
        setSeconds(setMinutes(setHours(new Date(), 23), 59), 59),
        'dd/MM/yyyy HH:mm:ss'
      ),
    []
  );

  const handleCloseReport = useCallback(() => {
    setOpen(false);
  }, []);

  const handleValidate = useCallback(
    async (data) => {
      try {
        const schema = Yup.object().shape({
          // datahorainicial: Yup.string().required(
          //   t('s.geral.validacao.campoobrigatorio')
          // ),
          // datahorafinal: Yup.string().required(
          //   t('s.geral.validacao.campoobrigatorio')
          // ),
          datahorainicial: Yup.date()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio')),
          datahorafinal: Yup.date()
            .typeError(t('s.geral.validacao.campoobrigatorio'))
            .transform((_, value) => parseDateString(value))
            .required(t('s.geral.validacao.campoobrigatorio'))
            .max(
              datahorafinal,
              `A data não pode ser superior a ${datahorafinal}`
            )
            .min(
              Yup.ref('datahorainicial'),
              'A data não pode ser inferior a Data inicial'
            ), 
          produto: Yup.string()
            .nullable()
            .required(t('s.geral.validacao.campoobrigatorio')
            ),
        });

        if (!umPosto && isEmpty(posts)) {
          throw 'Selecione ao menos um posto para continuar';
        }

        await schema.validate(data, { abortEarly: false });
      } catch (err) {
        const form = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            form[error.path] = error.message.replace(`${error.path} `, '');
          });

          throw { form };
        } else {
          throw err;
        }
      }
    },
    [posts]
  );

  const onSerializeData = useCallback(
    (data) => ({
      ...data,
      tipo: data.formato,
      posto: postoDescricaoAbrev,
      produto: produto.prod_codigo ? produto.prod_codigo.toString() : '0',
      produtostr: produto.prod_display,
      ...posts.reduce(
        (a, b, key) => Object.assign(a, { [`posto${key}`]: b.poco_codigo }),
        {}
      ),
    }),
    [produto, posts, postoDescricaoAbrev]
  );

  return (
    <Report
      open={open}
      onClose={handleCloseReport}
      serialize={onSerializeData}
      validate={handleValidate}
      title="Vazão Não Autorizada dos Postos no Período"
      relatorio="VAZAONAOAUTORIZADAPOSTOPERIODOPOSTOS"
      initials={{
        datahorainicial,
        datahorafinal,
        formato: 'pdf',
        postocodigo: profile.glousuariopostocodigo,
      }}
    >
      {/* <DateTime time label="Data Inicial" name="datahorainicial" />
      <DateTime time label="Data Final" name="datahorafinal" /> */}

      <DateTime
        time
        disableFuture
        label="Data Inicial"
        name="datahorainicial"
      />

      <DateTime
        time
        disableFuture
        label="Data Final"
        name="datahorafinal"
        maxDateMessage=""
      />


      <Autocomplete
        name="produto"
        label="prod_descricao"
        title="produtos"
        url="produtos"
        unique="prod_codigo"
        getValue={(value) => setProduto(value)}
      />

      {!umPosto && (
        <>
          <ListTransfer
            leftTitle="Postos Disponíveis"
            rightTitle="Postos Selecionados"
            transfer="complete"
            url="postosporusuario"
            onCallback={(value) => setPosts(value)}
            maxWidth={22}
            maxHeight={200}
            label="poco_desc_abrev"
            unique="poco_codigo"
          />
        </>
      )}

      {umPosto && (
        <>
          <Autocomplete
            name="postocodigo"
            label="poco_desc_abrev"
            unique="poco_codigo"
            title="Posto"
            url="postosporusuario"
            disabled
            getValue={(value) => setPostoDescricaoAbrev(value.poco_desc_abrev)}
          />
        </>
      )}

      <RadioGroup
        name="formato"
        label="Formato"
        options={[
          { label: 'PDF', value: 'pdf' },
          { label: 'Excel', value: 'xls' },
        ]}
        defaultValue="pdf"
        row
      />
    </Report>
  );
}
